import { Box, CircularProgress, Typography } from '@mui/material';
import { themeConstants } from './themeConstants';
import { useTranslation } from 'react-i18next';

interface Props {
  header?: React.ReactNode;
  message?: string;
  fullScreen?: boolean;
}

export default function LoadingComponent({
  header,
  message = 'common.loading',
  fullScreen = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {header}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height={fullScreen ? '100vh' : '100%'}
        minHeight={fullScreen ? 'auto' : '200px'}
        gap={2}
        sx={{
          backgroundColor: fullScreen ? 'background.default' : 'transparent',
          position: fullScreen ? 'fixed' : 'static',
          top: 0,
          left: 0,
          zIndex: fullScreen ? 9999 : 'auto',
        }}
      >
        {fullScreen && (
          <>
            <img
              src="/assets/images/smartristo-wifi-cup.svg"
              alt="SmartRisto Logo"
              style={{ width: '100px', height: '100px' }}
            />
            <Typography
              variant="h5"
              sx={{ mt: 2, mb: 2, color: themeConstants.primary.main }}
            >
              SmartRisto
            </Typography>
          </>
        )}
        <CircularProgress
          sx={{ color: themeConstants.primary.main }}
          size={fullScreen ? 60 : 40}
        />
        {!fullScreen && (
          <Typography color="text.secondary" variant="body1">
            {t(message)}
          </Typography>
        )}
      </Box>
    </>
  );
}
